// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__17txy","name":"Header_name__2T5y5","birthday":"Header_birthday__12jF0","skeleton":"Header_skeleton__1LvzS"};